module.exports = __webpack_public_path__ + "img/gift-cover.e924c6d1.png";